import { render } from "./refundList.vue?vue&type=template&id=192418f2&scoped=true"
import script from "./refundList.vue?vue&type=script&lang=js"
export * from "./refundList.vue?vue&type=script&lang=js"

import "./refundList.vue?vue&type=style&index=0&id=192418f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-192418f2"

export default script